import {h} from 'preact';
import {AppContextProvider} from "../../contexts/AppContext/appContext";
import {UserContextProvider} from "../../contexts/UserContext/userContext";
import {MemoContextProvider} from "../../contexts/MemoContext/memoContext";
import { GtmContextProvider } from '../../contexts/GTMContext/gtmContext';
import {BehavioralContextProvider} from "../../contexts/BehavioralContext/behavioralContext";

/**
 * Simple wrapper for all the global contexts that will be used throughout the application.
 *
 * Each new global context created should be declared here instead of the app.js file.
 * This provides both a cleaner and a better readable code.
 * */
const ContextsWrapper = props => {
    // Destructured props
    const {children} = props;

    return (
        <AppContextProvider>
            <GtmContextProvider>
                <UserContextProvider>
                    <MemoContextProvider>
                        <BehavioralContextProvider>
                            {children}
                        </BehavioralContextProvider>
                    </MemoContextProvider>
                </UserContextProvider>
            </GtmContextProvider>
        </AppContextProvider>
    )
}

export default ContextsWrapper;
